module.exports = __webpack_public_path__ + "img/焦作市-c.3f14d7a2.png";